export default __webpack_public_path__ + "static/media/Masque-ruban-02.bfb56ab3.png";